export default __webpack_public_path__ + "static/media/orpheus-logo-with-text.3c6d67e6.png";